import { Select } from '@mui/material';

import { alpha, styled } from '@mui/material/styles';

const RegularDropdown = styled(Select)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
  '& .MuiSelect-nativeInput' : {
    border: 'none'
  },
  '& .MuiInputBase-input': {
    borderRadius: 10,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#111633',
    border: '1px solid #484c63',
    fontSize: 16,
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover' : {
      borderColor: '#cbccd280'
    },
    '&:focus': {
      padding: "9px 11px",
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
      borderRadius: 10,
    },
  },
}));

export default RegularDropdown;